import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './ClickableElement.scss';
import { connect } from 'react-redux';
import {
  analyticsClick as analyticsClickActionCreator,
  AnalyticsClick,
  ClickAnalyticsOptions,
} from 'src/redux/modules/analytics';
import { bindActionCreators } from 'redux';

interface OwnProps {
  id?: string;
  analyticsOptions?: ClickAnalyticsOptions;
  className?: string;
  inline?: boolean;
  onClick?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  isDisabled?: boolean;
  onMouseDown?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  onTouchStart?: React.EventHandler<React.TouchEvent<HTMLElement>>;
}

interface DispatchProps {
  analyticsClick: AnalyticsClick;
}

type Props = OwnProps & DispatchProps;

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      analyticsClick: analyticsClickActionCreator as AnalyticsClick,
    },
    dispatch
  );

class ClickableElement extends React.Component<Props, {}> {
  static defaultProps: {
    isDisabled: false;
  };

  constructor(props: Props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: React.MouseEvent<HTMLElement>) {
    const { onClick, analyticsClick, analyticsOptions } = this.props;
    if (onClick) {
      onClick(e);
    }
    if (analyticsOptions) {
      analyticsClick(analyticsOptions);
    }
  }

  render() {
    const {
      id,
      inline,
      children,
      className,
      isDisabled,
      onMouseDown,
      onTouchStart,
    } = this.props;
    return (
      <button
        id={id}
        type="button"
        className={className}
        onClick={this.handleClick}
        styleName={
          inline ? 'clickable-element-inline' : 'clickable-element-block'
        }
        disabled={isDisabled}
        data-disabled={isDisabled}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      >
        {children}
      </button>
    );
  }
}

export default connect<{}, DispatchProps, OwnProps>(
  null,
  mapDispatchToProps
)(CSSModules(ClickableElement, styles));



// WEBPACK FOOTER //
// ./src/components/ClickableElement/ClickableElement.tsx